import { Head } from "@inertiajs/react";

const ContestConditions = () => {
  return (
    <>
      <Head title="Mentions légales - Review car" />
      <h1 className="text-center lg:max-w-[75%] mx-auto mt-10 mb-10 flex flex-col items-center justify-center gap-2">
        Les règles du jeu
        {/* <span className="text-primary">500 € de cadeaux</span> */}
      </h1>
      <span className="text-center">Dernière mise à jour : Juillet 2026</span>

      <p className="text-center mt-8">
        <b>Version synthétique</b>: Le règlement complet, incluant les modalités
        détaillées des tirages au sort et la description des lots, est
        disponible sur simple demande.
      </p>
      <div className="max-w-screen-lg mx-auto mt-10 px-2">
        <h4 className="primary-color font-bold text-xl mb-4 mt-8">
          1. Organisateur
        </h4>
        <p className="mb-4">
          La société Qualimetrie, Société par actions simplifiée au capital de
          37 000 €, dont le siège social est situé 6 avenue de Flandre – 59491
          Villeneuve d’Ascq, immatriculée au RCS Lille Métropole sous le numéro
          350 899 225 (ci-après « l’Organisateur »), exploite le site internet :
          <br />
          <a
            href="https://www.review-car.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            https://www.review-car.com
          </a>
          <br />
          et organise un jeu concours gratuit sans obligation d’achat (ci-après
          « le Jeu ») selon les modalités décrites dans le présent règlement..
        </p>

        {/* <h4 className="primary-color font-bold text-xl mb-4 mt-8">
          2. Objet du Jeu
        </h4>
        <p className="mb-4">
          Le Jeu a pour objectif de promouvoir l’utilisation du site Review Car
          et la publication d’avis d’utilisateurs sur leurs expériences liées à
          l’automobile.
          <br />
          La participation au Jeu implique l’acceptation pleine et entière du
          présent règlement.
        </p> */}

        <h4 className="primary-color font-bold text-xl mb-4 mt-8">
          2. Comment participer aux votes
        </h4>
        <p className="mb-4">
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>Les votes sont ouverts à tous via notre plateforme.</li>
            <li>
              Chaque participant peut voter pour ses modèles préférés parmi les
              12 véhicules nominés.
            </li>
            <li>
              Les votes sont pris en compte jusqu'au 30 septembre 2026 à 23h59.
            </li>
            <li>
              Les résultats sont annoncés et les prix remis le 15 octobre 2026
              pendant le salon.
            </li>
          </ul>
        </p>

        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          3. Jeu-concours de participation
        </h4>
        <p className="mb-2">
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              Tous les votants participent automatiquement à un tirage au sort.
            </li>
            <li>
              Des lots en lien avec la mobilité électrique sont à gagner (bons
              de recharge, avantages autour du VE…).
            </li>
          </ul>
        </p>

        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          4. 1 an de recharge à gagner pour les propriétaires
        </h4>
        <p className="mb-4">
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              Si un votant est propriétaire ou utilisateur habituel de l'un des
              12 modèles nominés et vote pour ce véhicule, il peut participer à
              un tirage au sort dédié.
            </li>
            <li>
              À la clé : 1 an de recharge (selon les modalités précisées dans le
              règlement complet du concours).
            </li>
          </ul>
        </p>

        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          5. Avantages pour les marques nominées
        </h4>
        <p className="mb-4">
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              Visibilité renforcée sur la plateforme et dans les communications.
            </li>
            <li>
              Kit de communication global : visuels « Nominé », contenus prêts à
              l'emploi pour les réseaux sociaux, éléments de langage pour les
              équipes et réseaux (concessions, distributeurs).
            </li>
          </ul>
        </p>

        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          6. Désignation des véhicules gagnants
        </h4>
        <p className="mb-4">
          Les véhicules nominés concourent au sein de leur catégorie respective
          : « Citadines électriques » ou « Familiales électriques ».
          <br />
          Pour pouvoir être désigné vainqueur de sa catégorie, un véhicule doit
          avoir recueilli <strong>au minimum 30 avis valides</strong> avant la
          clôture des votes, fixée au 30 septembre 2026 à 23h59.
          <br />
          Parmi les véhicules ayant atteint ce seuil minimum de 30 votes,{" "}
          <strong>
            le véhicule obtenant la meilleure note moyenne est désigné vainqueur
            de sa catégorie
          </strong>
          , quel que soit le nombre total d'avis recueillis au-delà de ce seuil.
          <br />
          Ainsi, dès lors que le seuil de 30 votes est atteint, le nombre de
          votes n'intervient pas dans le classement final :{" "}
          <strong>
            seule la note moyenne obtenue détermine le véhicule gagnant de
            chaque catégorie
          </strong>
          .
        </p>

        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          7. Désignation du votant gagnant
        </h4>
        <p>
          Un gagnant sera désigné par tirage au sort parmi les participants
          éligibles.
          <br />
          Le tirage au sort sera réalisé dans un délai de 15 jours suivant la
          fin du jeu.
          <br />
          Le gagnant sera contacté par e-mail.
          <br />
          Sans réponse sous 15 jours, le lot pourra être réattribué.
        </p>

        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          8. Responsabilité
        </h4>
        <p className="mb-4">
          L’Organisateur ne pourra être tenu responsable :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>en cas de problème technique empêchant la participation</li>
            <li>
              en cas d’interruption ou modification du Jeu pour des raisons
              indépendantes de sa volonté
            </li>
          </ul>
        </p>

        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          9. Données personnelles
        </h4>
        <p className="mb-4">
          Les données collectées (nom, e-mail, avis) sont traitées par
          QUALIMETRIE, responsable de traitement, sur la base de son{" "}
          <b>intérêt légitime</b>, aux fins de gestion du Jeu et de publication
          des avis sur review-car.com.
          <br />
          La fourniture du nom et de l’e-mail est obligatoire pour participer.
          <br />
          Ces informations sont exclusivement destinées aux services habilités
          de QUALIMETRIE et sont conservées pendant la durée du Jeu, augmentée
          d’un délai de <b>3 mois après la remise du lot</b>.
          <br />
          À l’issue de ce délai, les données d’identification seront supprimées.
          <br />
          Les données sont hébergées sur des serveurs situés au sein de l’Union
          Européenne.
          <br />
          Conformément au RGPD, les participants disposent :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>d'un droit d'accès</li>
            <li>de rectification</li>
            <li>d'effacement</li>
            <li>de limitation</li>
            <li>de d'opposition</li>
          </ul>
          Pour exercer ces droits : <b>dpo@qualimetrie.com</b>
          <br />
          Les participants disposent également du droit d’introduire une
          réclamation auprès de la CNIL (
          <a
            href="https://www.cnil.fr"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            www.cnil.fr
          </a>
          ).
          <br />
          Pour plus d’informations, les participants peuvent consulter la
          politique de confidentialité disponible sur le site.
        </p>

        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          10. Acceptation du règlement
        </h4>
        <p className="mb-4">
          La participation au Jeu implique l’acceptation sans réserve du présent
          règlement.
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          11. Droit applicable
        </h4>
        <p className="mb-4">
          Le présent règlement est soumis au droit français.
          <br />
          Tout litige sera soumis aux tribunaux compétents du ressort du siège
          social de l’Organisateur.
        </p>
      </div>
    </>
  );
};

export default ContestConditions;
